import React, { createContext, useContext, useEffect } from "react";
import useAudio from "./hooks/useAudio";
import { useGameStateContext } from "./GameStateProvider";

const AudioContext = createContext(null);

export const useAudioContext = () => {
  const ctx = useContext(AudioContext);
  if (!ctx) throw new Error("useAudioContext must be used within AudioProvider");
  return ctx;
};

const AudioProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { state } = useGameStateContext();
  const audio = useAudio({
    musicVolume: state.settings.musicVolume,
    sfxVolume: state.settings.sfxVolume,
  });

  // Show audio initialization status to user if needed
  useEffect(() => {
    if (!audio.audioInitialized) {
      console.log("Audio not yet initialized. Click anywhere to enable sound.");
    }
  }, [audio.audioInitialized]);

  return <AudioContext.Provider value={audio}>{children}</AudioContext.Provider>;
};

export default AudioProvider;
